export default "__VITE_ASSET__5cf8c0f2__"